'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
require('medium-editor/dist/css/medium-editor.css');
require('medium-editor/dist/css/themes/bootstrap.css');
var _reactMediumEditor = require('react-medium-editor');
var _reactMediumEditor2 = _interopRequireDefault(_reactMediumEditor);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  Button: {
    textDecoration: 'none',
    textAlign: 'center',
    boxSizing: 'border-box',
    display: 'inline-block',
    transition: 'background-color 0.25s, color 0.25s, border-color 0.25s',
    paddingTop: function paddingTop(_ref) {
      var verticalPadding = _ref.otherProperties.verticalPadding;
      return verticalPadding;
    },
    paddingBottom: function paddingBottom(_ref2) {
      var verticalPadding = _ref2.otherProperties.verticalPadding;
      return verticalPadding;
    },
    paddingLeft: function paddingLeft(_ref3) {
      var horizontalPadding = _ref3.otherProperties.horizontalPadding;
      return horizontalPadding;
    },
    paddingRight: function paddingRight(_ref4) {
      var horizontalPadding = _ref4.otherProperties.horizontalPadding;
      return horizontalPadding;
    },
    color: function color(_ref5) {
      var _color = _ref5.otherProperties.color;
      return _color;
    },
    backgroundColor: function backgroundColor(_ref6) {
      var _backgroundColor = _ref6.otherProperties.backgroundColor;
      return _backgroundColor;
    },
    borderStyle: 'solid',
    borderWidth: function borderWidth(_ref7) {
      var _borderWidth = _ref7.otherProperties.borderWidth;
      return _borderWidth;
    },
    borderColor: function borderColor(_ref8) {
      var _borderColor = _ref8.otherProperties.borderColor;
      return _borderColor;
    },
    borderRadius: function borderRadius(_ref9) {
      var _borderRadius = _ref9.otherProperties.borderRadius;
      return _borderRadius;
    },
    '&:hover': {
      color: function color(_ref10) {
        var hoveredColor = _ref10.otherProperties.hoveredColor;
        return hoveredColor;
      },
      backgroundColor: function backgroundColor(_ref11) {
        var hoveredBackgroundColor = _ref11.otherProperties.hoveredBackgroundColor;
        return hoveredBackgroundColor;
      },
      borderColor: function borderColor(_ref12) {
        var hoveredBorderColor = _ref12.otherProperties.hoveredBorderColor;
        return hoveredBorderColor;
      }
    },
    '& .content': {
      minHeight: 'initial',
      outline: 0,
      '& p': {
        margin: 0,
        wordWrap: 'break-word'
      }
    }
  }
};
var Button = function (_Component) {
  _inherits(Button, _Component);
  function Button() {
    _classCallCheck(this, Button);
    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }
  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        children = _props.children,
        value = _props.value,
        editable = _props.editable,
        onChangeText = _props.onChangeText;
      var href = otherProperties.href,
        target = otherProperties.target;
      var registerRegexp = /(dmz\/.+\/website\/register|live\.eventtia\.com)/;
      var options = {
        toolbar: false
      };
      return _react2.default.createElement('a', {
        className: classes.Button,
        href: editable ? undefined : registerRegexp.test(href) ? '' + href + window.location.search : href,
        target: target,
        style: cssProperties
      }, editable ? _react2.default.createElement(_reactMediumEditor2.default, {
        className: 'content',
        text: value,
        options: options,
        onChange: onChangeText
      }) : _react2.default.createElement('div', {
        className: 'content',
        dangerouslySetInnerHTML: {
          __html: value
        }
      }));
    }
  }]);
  return Button;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(Button);